import { useEffect, useMemo, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import "./ColumnCharts.css";

const ColumnCharts = ({ dataChart, ...props }) => {
	const {listaData, listaNombres} = dataChart;
	const [series, setSeries] = useState(listaData);
	const chartIdRef = useRef(`chart-${Math.random().toString(36).substr(2, 9)}`);

	useEffect(() => {
		setSeries(listaData);
	}, [dataChart]);

	const seriesCount = Array.isArray(listaData) ? listaData.length : 1;
	const categoriesCount = Array.isArray(listaNombres) ? listaNombres.length : 1;
	const minChartWidth = Math.max(500, categoriesCount * seriesCount * 48 + 160);

	const options = useMemo(() => ({
		chart: {
			id: chartIdRef.current,
			type: 'bar',
			toolbar: {
				show: false,
			}
		},
		plotOptions: {
			bar: {
				horizontal: false,
				columnWidth: '25px',
				endingShape: 'rounded',
				dataLabels: {
					position: 'center',
					orientation: 'vertical'
				}
			},
		},
		dataLabels: {
			enabled: true,
			formatter: function (val) {
				return Math.round(val) + " %";
			},
			style: {
				colors: ['#FFFFFF'],
				fontSize: '10px',
				fontWeight: '600'
			},
			background: {
				enabled: true,
				foreColor: '#FFFFFF',
				borderRadius: 4,
				padding: 4,
				opacity: 0.75,
				borderWidth: 1,
				borderColor: '#1C1C1C',
				dropShadow: {
					enabled: false
				}
			}
		},
		stroke: {
			show: true,
			width: 0.8,
			colors: ['#FFFFFF']
		},
		xaxis: {
			categories: listaNombres
		},
		fill: {
			opacity: 1,
			colors: ['#FC0000', '#E65D29', '#49B461','#FF4560','#775DD0','#008FFB', '#00E396','#FEB019', '#AEB6BF', '#85C1E9', '#34495E']
		},
		tooltip: {
			enabled: false
		},
		legend: {
			position: 'top',
			horizontalAlign: 'left',
			fontFamily: '"Poppins", sans-serif',
			fontSize: '14px',
			labels: {
				colors: ['#809FB8'],
			},
			markers: {
				fillColors: ['#FC0000', '#E65D29', '#49B461','#FF4560','#775DD0','#008FFB', '#00E396','#FEB019', '#AEB6BF', '#85C1E9', '#34495E'],
				radius: 17,
			}
		},
	}), [listaNombres]);

	return(
		<div className="column-charts-scroll-wrapper">
			<div id="chart" className="column-charts" style={{ minWidth: `${minChartWidth}px` }}>
				<ReactApexChart
					options={options}
					series={series}
					type="bar"
					height="100%"
				/>
			</div>
		</div>
	)
}
export default ColumnCharts;
